import React, { forwardRef } from "react"
import { useSelector } from "react-redux"
import { Dropdown } from "react-bootstrap"
import { FaCaretDown } from "react-icons/fa6"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Tooltip } from "components"
import classes from "./TnSnappboxDropdown.module.scss"

const TnSnappboxDropdown = (props) => {
  const { selectedBranch, setSelectedBranch } = props

  const i18n = useTranslation()[1]

  const userBranches =
    useSelector(state => state.userAccountInfo.userBranches)

  const handleSelect = (branch) => {
    if (selectedBranch._id === branch._id) return

    localStorage.setItem("ssbid", branch._id)

    setSelectedBranch(branch)
  }

  const dir =
    i18n.dir(i18n.language)

  const hideBranchDropdown =
    userBranches.length <= 1

  if (hideBranchDropdown) return null

  return (
    <Dropdown className={classes["dropdown-button"]}>
      <Dropdown.Toggle
        as={forwardRef((props, ref) =>
          <Tooltip
            title={selectedBranch.name}
          >
            <button
              ref={ref}
              {...props}
              className={classes["button"]}
            >
              <FaCaretDown size={20} />
            </button>
          </Tooltip>
        )}
      />

      <Dropdown.Menu
        align={dir === "rtl" ? "end" : "start"}
        style={{ margin: 0 }}
      >
        {userBranches.map(ub =>
          <Dropdown.Item
            key={ub._id}
            onClick={() => handleSelect(ub)}
            className={clsx(
              classes["item"],
              selectedBranch._id === ub._id && classes["active"]
            )}
          >
            {ub.name}
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown >
  )
}

export default TnSnappboxDropdown